// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogSv = {
  "controls": {
    "boot": "Starta",
    "reset": "Återställ",
    "copyScreen": "Kopiera skärm",
    "copyText": "Kopiera text",
    "pasteText": "Klistra in text",
    "saveState": "Spara tillstånd",
    "restoreState": "Återställ tillstånd",
    "toggleSound": "Växla ljud",
    "retrySound": "Ljud är inte tillgängligt. Försök med ljud igen.",
    "settings": "Inställningar",
    "debugPanel": "Felsökningspanel",
    "infoPanel": "Informationspanel",
    "reportIssue": "Rapportera ett problem",
    "privacyPolicy": "Integritetspolicy"
  },
  "config": {
    "speed": "Emulatorhastighet",
    "display": "Skärminställningar",
    "theme": "Tema",
    "openRetroControlPanel": "Kontrollpanel",
    "resetSettings": "Återställ alla inställningar",
    "resetSettingsText": "Är du säker på att du vill återställa alla inställningar? Detta raderar inte dina brytpunkter eller ditt BASIC-program.",
    "capsLock": "Caps Lock",
    "useOpenApple": "Använd tangenten {{modKey}} för Open Apple",
    "useShortcuts": "Använd tangenten {{modKey}} för kortkommandon",
    "useArrowKeys": "Använd piltangenter som styrspak",
    "scanlines": "CRT-skanningslinjer",
    "ghosting": "Fosforefterlysning",
    "crtDistortion": "CRT-förvrängning",
    "joystick": "Tangentbord och styrspakskonfiguration"
  },
  "machine": {
    "configuration": "Maskinkonfiguration",
    "slotConfigurator": "Expansionskortplatser",
    "models": {
      "apple2p": "Apple II+",
      "apple2eu": "Apple IIe (utan utökning)",
      "apple2ee": "Apple IIe (utökad)"
    },
    "ram": {
      "64kb_aux": "64 KB (AUX)",
      "512kb": "512 KB",
      "1024kb": "1 024 KB",
      "4mb": "4 MB",
      "8mb": "8 MB"
    }
  },
  "speed": {
    "snail": "Snigelhastighet (0,1 MHz)",
    "slow": "Långsam hastighet (0,5 MHz)",
    "normal": "Normal hastighet (1 MHz)",
    "two": "2 MHz",
    "three": "3 MHz",
    "fast": "Snabb hastighet (4 MHz)",
    "warp": "Löjlig hastighet"
  },
  "colors": {
    "color": "Färg",
    "nofringe": "Färg (utan fransar)",
    "green": "Grön",
    "amber": "Bärnsten",
    "white": "Svartvitt",
    "inverse": "Svartvitt (inverterat)"
  },
  "timetravel": {
    "configuration": "Tidsresor konfiguration",
    "snapshotOnKeyPress": "Ta ögonblicksbild vid knapptryckning",
    "autoSnapshot": "Automatisk ögonblicksavbild",
    "auto_Off": "Av",
    "auto_100k": "Var 0,1 s (100 000 cykler)",
    "auto_1M": "Var 1 sekund (1 miljon cykler)"
  },
  "themes": {
    "classic": "Klassisk",
    "dark": "Mörk",
    "minimal": "Minimal"
  },
  "debug": {
    "helpPanel": "Visa hjälppanel",
    "debugPanel": "Visa felsökningspanel",
    "expectinPanel": "Visa panelen Apple exPectin",
    "helpTab": "Hjälp",
    "debugTab": "Felsökning",
    "basicTab": "Applesoft BASIC",
    "expectinTab": "Apple exPectin",
    "breakpoints": "Brytpunkter",
    "memory": "Minne",
    "stack": "Stack",
    "state": "CPU-tillstånd",
    "registers": "Register",
    "flags": "Flaggor",
    "step": "Stega",
    "stepOver": "Stega över",
    "stepInto": "Stega in",
    "stepOut": "Stega ut",
    "resume": "Återuppta",
    "pause": "Pausa",
    "loadSymbolTable": "Läs in symboltabell",
    "agentTab": "Agent",
    "disassembly": "Avassemblering",
    "breakOnce": "Gör ett avbrott och ta sedan bort",
    "basicLineNumber": "BASIC-radnummer:",
    "any": "Valfri",
    "stackDump": "Stackdump",
    "timeTravelSnapshots": "Ögonblicksbilder för tidsresor",
    "heatMapTitle": "Värmekarta",
    "memoryDumpTitle": "Minnesdump",
    "veraMonitor": "VERA-monitor",
    "pauseForDisassembly": "Pausa för att visa disassemblering",
    "cycles": "Cykler:",
    "resetCycleCountAndHeatMaps": "Återställ cykelräknaren och värmekartorna",
    "breakpointTitle": "Redigera brytpunkt",
    "breakpoint": {
      "breakAt": "Bryt vid:",
      "breakpoint": "Brytpunkt",
      "watchpoint": "Övervakningspunkt",
      "instruction": "Instruktion",
      "address": "Adress:",
      "hitCount": "Träffräknare:",
      "expression": "Uttryck:",
      "memoryBank": "Minnesbank:",
      "opcode": "Opkod:",
      "addressingMode": "Läge:",
      "value": "Värde:",
      "anyIllegal65C02": "Valfri otillåten 65C02-opkod",
      "anyIllegal6502": "Valfri otillåten 6502-opkod",
      "read": "Läs",
      "write": "Skriv",
      "withHexValue": "Med hexadecimalt värde:",
      "actions": "Åtgärder:",
      "haltAfterActions": "Stoppa körningen efter åtgärder",
      "actionAddress": "adress",
      "actionToAddress": "till adress",
      "actionToValue": "till värde",
      "add": "Lägg till ny brytpunkt",
      "removeAll": "Ta bort alla brytpunkter",
      "edit": "Redigera brytpunkt",
      "delete": "Ta bort brytpunkt",
      "action": {
        "none": "(ingen åtgärd)",
        "set": "Ställ in",
        "jump": "Hoppa till",
        "print": "Skriv ut i konsolen",
        "snapshot": "Ögonblicksbild"
      },
      "register": {
        "address": "Adress",
        "accumulator": "Ackumulator",
        "x": "X-register",
        "y": "Y-register",
        "stack": "Stackpekare",
        "status": "Processorstatus",
        "programCounter": "Programräknare"
      },
      "mode": {
        "implied": "Implicit",
        "immediate": "Omedelbar",
        "zeroPageRelative": "Nollsida/relativ",
        "zeroPageX": "Nollsida, X",
        "zeroPageY": "Nollsida, Y",
        "absolute": "Absolut",
        "absoluteX": "Absolut, X",
        "absoluteY": "Absolut, Y",
        "indirectX": "Indirekt, X",
        "indirectY": "Indirekt, Y",
        "indirect": "Indirekt"
      }
    },
    "heatMap": {
      "cpuProgramCounter": "6502-programräknare",
      "count": "Antal",
      "getMemoryCalls": "Minnesläsningar",
      "setMemoryCalls": "Minneskrivningar",
      "colorTable": "Färgtabell",
      "showMagnifier": "Visa förstoringsglas",
      "jumpToProgramCounter": "Hoppa till aktuell programräknare",
      "jumpToMaximumValue": "Hoppa till högsta värdet i värmekartan"
    },
    "memoryDump": {
      "pickWatchpoint": "Välj övervakningspunkt",
      "saveMemory": "Spara minne",
      "highBitAscii": "ASCII med hög bit",
      "searchHex": "Sök hexadecimalt",
      "searchAscii": "Sök ASCII",
      "noMatch": "ingen träff",
      "matchCount": "{{match}} av {{total}}",
      "previousMatch": "Föregående träff",
      "nextMatch": "Nästa träff",
      "range": {
        "current": "Aktuellt minne",
        "mainRam": "Huvud-RAM",
        "auxiliaryRam": "Hjälp-RAM",
        "hgr1": "HGR-sida 1",
        "hgr2": "HGR-sida 2"
      }
    },
    "disassemblyPreviousLocation": "Föregående plats",
    "disassemblyNextLocation": "Nästa plats",
    "memoryMap": {
      "title": "Minneskarta",
      "read": "Läs",
      "write": "Skriv",
      "zeroPage": "Nollsida",
      "stack": "Stack",
      "text": "Text",
      "hiresMode": "Högupplöst",
      "hires": "HGR",
      "internalRom": "Internt ROM",
      "slotRom": "Kortplats-ROM",
      "auxBank": "Hjälpbank",
      "auxRead": "Hjälpläsning",
      "auxWrite": "Hjälpskrivning",
      "store80": "80 Store",
      "mixed": "Blandat",
      "page2": "Sida 2",
      "columns80": "80 kolumner",
      "doubleHires": "Dubbel högupplösning",
      "video7Mono": "V7 mono",
      "video7160": "V7 160x",
      "video7Mixed": "V7 blandat",
      "internalCxxxRom": "Internt Cxxx-ROM",
      "internalC300Rom": "Internt C300-ROM",
      "readRam": "Läs RAM",
      "writeRam": "Skriv RAM",
      "bank2Switch": "Bank 2"
    }
  },
  "disassembly": {
    "memory": {
      "effectiveAddress": "Effektiv adress: {{notation}}",
      "value": "Värde: {{notation}}"
    },
    "keyboard": {
      "character": "Tangentbord: ”{{character}}”",
      "strobeClear": "Tangentbordsstrobe: RENSAD (MSB = 0)",
      "strobeSet": "Tangentbordsstrobe: SATT (MSB = 1)",
      "anyKeyDownClear": "Flagga för någon tangent nedtryckt: RENSAD (MSB = 0)",
      "anyKeyDownSet": "Flagga för någon tangent nedtryckt: SATT (MSB = 1)",
      "clearStrobe": "Rensa tangentbordsstrobe"
    },
    "cassette": {
      "toggleOutput": "Växla kassettutgång",
      "sampleInput": "Sampla kassettindata",
      "sampleInputMirror": "Sampla spegling av kassettindata"
    },
    "speaker": {
      "toggleOutput": "Växla högtalarutgång"
    },
    "notice": {
      "emulatorIdentifier": "INFO: Apple2TS-emulatoridentifierare: $CD",
      "noWriteEffect": "INFO: Den här skrivningen påverkar inte {{machine}}",
      "multipleTriggers": "VARNING: Den här instruktionen utlöser den mjuka brytaren flera gånger",
      "unknownWrite": "VARNING: Den här instruktionen skriver ett okänt värde"
    },
    "rom": {
      "intCxOff": "Intern $Cx-ROM: AV (MSB = 0)",
      "intCxOn": "Intern $Cx-ROM: PÅ (MSB = 1)",
      "slot3Off": "Kortplats 3-ROM: AV (MSB = 0)",
      "slot3On": "Kortplats 3-ROM: PÅ (MSB = 1)",
      "internal": "Välj intern ROM för {{range}}",
      "slot": "Välj kortplats-ROM för {{range}}"
    },
    "languageCard": {
      "bank1": "Language Card-bank: 1 (MSB = 0)",
      "bank2": "Language Card-bank: 2 (MSB = 1)",
      "readSourceRom": "Language Card-läskälla: ROM (MSB = 0)",
      "readSourceRam": "Language Card-läskälla: RAM (MSB = 1)",
      "selectBank": "Language Card: välj bank {{bank}}",
      "useRamForReads": "Language Card: använd RAM vid läsning",
      "useRomForReads": "Language Card: använd ROM vid läsning",
      "disableWrites": "Language Card: inaktivera skrivningar",
      "resetPrewriteLatch": "Language Card: återställ spärr för förskrivning",
      "armOrEnableWrites": "Language Card: förbered eller aktivera skrivningar"
    },
    "auxMemory": {
      "readStatusOff": "Läsningar från extraminne: AV (MSB = 0)",
      "readStatusOn": "Läsningar från extraminne: PÅ (MSB = 1)",
      "readMain": "Välj huvudminne för läsning",
      "readAuxiliary": "Välj extraminne för läsning",
      "writeStatusOff": "Skrivningar till extraminne: AV (MSB = 0)",
      "writeStatusOn": "Skrivningar till extraminne: PÅ (MSB = 1)",
      "writeMain": "Välj huvudminne för skrivning",
      "writeAuxiliary": "Välj extraminne för skrivning",
      "selectExpansionBank": "Välj bank {{bank}} i extraminne med {{addressing}}-adressering",
      "altzpMain": "Välj huvudsida noll, stack och bankväxlat RAM",
      "altzpAuxiliary": "Välj extrasida noll, stack och bankväxlat RAM",
      "altzpStatusMain": "Sida noll, stack och bankväxlat RAM: HUVUD (MSB = 0)",
      "altzpStatusAuxiliary": "Sida noll, stack och bankväxlat RAM: EXTRA (MSB = 1)"
    },
    "displayMemory": {
      "80storeStatusOff": "PAGE2 väljer bildskärmssida 1 eller 2 (MSB = 0)",
      "80storeStatusOn": "PAGE2 väljer huvud- eller extra bildskärmsminne (MSB = 1)",
      "80storeOff": "Låt PAGE2 välja bildskärmssida 1 eller 2",
      "80storeOn": "Låt PAGE2 välja huvud- eller extra bildskärmsminne",
      "page2StatusClear": "Val av bildskärmsminne: SIDA 1 ELLER HUVUD (MSB = 0)",
      "page2StatusSet": "Val av bildskärmsminne: SIDA 2 ELLER EXTRA (MSB = 1)",
      "selectPage1": "Välj bildskärmssida 1",
      "selectPage2": "Välj bildskärmssida 2",
      "page2Clear": "Välj bildskärmssida 1 eller huvudbildskärmsminne med 80STORE",
      "page2Set": "Välj bildskärmssida 2 eller extrabildskärmsminne med 80STORE"
    },
    "display": {
      "altCharsetStatusOff": "Alternativ teckenuppsättning: AV (MSB = 0)",
      "altCharsetStatusOn": "Alternativ teckenuppsättning: PÅ (MSB = 1)",
      "selectPrimaryCharset": "Välj primär teckenuppsättning",
      "selectAlternateCharset": "Välj alternativ teckenuppsättning",
      "textModeStatusOff": "Textläge: AV (MSB = 0)",
      "textModeStatusOn": "Textläge: PÅ (MSB = 1)",
      "selectGraphicsMode": "Välj grafikläge",
      "selectTextMode": "Välj textläge",
      "mixedDisplayStatusOff": "Blandad visning: AV (MSB = 0)",
      "mixedDisplayStatusOn": "Blandad visning: PÅ (MSB = 1)",
      "selectFullScreenDisplay": "Välj helskärmsvisning",
      "selectMixedDisplay": "Välj blandad grafik/text",
      "hiresModeStatusOff": "Högupplöst läge: AV (MSB = 0)",
      "hiresModeStatusOn": "Högupplöst läge: PÅ (MSB = 1)",
      "selectLoresGraphics": "Välj lågupplöst grafik",
      "selectHiresGraphics": "Välj högupplöst grafik",
      "disableDhires": "Inaktivera DHIRES",
      "enableDhires": "Aktivera DHIRES",
      "verticalBlankActive": "Vertikal blankning: AKTIV (MSB = 0)",
      "verticalBlankInactive": "Vertikal blankning: INAKTIV (MSB = 1)",
      "column80StatusOff": "80-kolumnsvisning: AV (MSB = 0)",
      "column80StatusOn": "80-kolumnsvisning: PÅ (MSB = 1)",
      "setWidth": "Ställ in visningsbredden till {{columns}} kolumner"
    },
    "annunciator": {
      "disable": "Inaktivera annunciator {{number}}",
      "enable": "Aktivera annunciator {{number}}"
    },
    "transWarp": {
      "configuredMaximum": "TransWarp: välj konfigurerad maximal hastighet",
      "oneMhz": "TransWarp: välj 1 MHz",
      "disableUntilColdBoot": "TransWarp: inaktivera acceleration tills kallstart"
    },
    "laser128ex": {
      "oneMhz": "Laser 128EX: välj 1 MHz som maximal CPU-hastighet",
      "twoPointThreeMhz": "Laser 128EX: välj 2,3 MHz som maximal CPU-hastighet",
      "threePointSixMhz": "Laser 128EX: välj 3,6 MHz som maximal CPU-hastighet",
      "disableDiskSlowdown": "Laser 128EX: inaktivera automatisk sänkning till 1 MHz för diskåtkomst på port 7 (skriv-en-gång-bit 5)",
      "enableDiskSlowdown": "Laser 128EX: aktivera automatisk sänkning till 1 MHz för diskåtkomst på port 7 (skriv-en-gång-bit 5)"
    },
    "gameIO": {
      "pulseStrobe": "Pulsera spelportsstrobe",
      "startPaddleTimers": "Starta paddeltimrar",
      "buttonReleased": "Tryckknapp {{number}}: SLÄPPT (MSB = 0)",
      "buttonPressed": "Tryckknapp {{number}}: NEDTRYCKT (MSB = 1)",
      "paddleExpired": "Timer för paddel {{number}}: UTGÅNGEN (MSB = 0)",
      "paddleActive": "Timer för paddel {{number}}: AKTIV (MSB = 1)",
      "buttonMirrorReleased": "Spegling av tryckknapp {{number}}: SLÄPPT (MSB = 0)",
      "buttonMirrorPressed": "Spegling av tryckknapp {{number}}: NEDTRYCKT (MSB = 1)",
      "paddleMirrorExpired": "Spegling av timer för paddel {{number}}: UTGÅNGEN (MSB = 0)",
      "paddleMirrorActive": "Spegling av timer för paddel {{number}}: AKTIV (MSB = 1)"
    }
  },
  "tour": {
    "welcome": "Välkommen till Apple2TS-emulatorn!",
    "clickNext": "Tryck på Nästa om du vill veta mer.",
    "bootButton": "Klicka här för att starta emulatorn.",
    "retroBootButton": "Välj det här alternativet för att starta emulatorn.",
    "resetButton": "Klicka här för att återställa Apple II och antingen starta om eller gå in i BASIC.",
    "retroResetButton": "Välj det här alternativet för att återställa Apple II och antingen starta om eller gå in i BASIC.",
    "diskImages": "Välj en av de installerade diskavbildningarna.",
    "floppyDisks": "Du kan också klicka på någon av diskettikonerna för att läsa in en diskavbildning.",
    "retroFloppyDisks": "Eller välj en diskenhet för att läsa in en diskavbildning.",
    "saveRestore": "Du kan spara och återställa emulatorns hela tillstånd med de här knapparna.",
    "retroSaveRestore": "Du kan spara och återställa emulatorns hela tillstånd med de här alternativen.",
    "themeButton": "Klicka här för att ändra emulatorns gränssnittstema.",
    "retroThemeButton": "Använd piltangenterna för att ändra emulatorns gränssnittstema.",
    "endTour": "Du har nått slutet av genomgången.",
    "tourSelectorHint": "Klicka på jordglobsknappen för att prova någon av de andra genomgångarna, eller tryck på Slutför för att börja använda emulatorn.",
    "retroTourSelectorHint": "Välj ett menyalternativ för att prova någon av de andra genomgångarna, eller tryck på Slutför för att börja använda emulatorn.",
    "settingsWelcome": "Apple2TS har en komplett uppsättning reglage för både emulatorn och Apple II.",
    "mainControls": "Här kan du starta och återställa Apple II, återställa och spara tillstånd, kopiera skärmen eller klistra in text i emulatorn.",
    "snapshot": "Du kan när som helst ta en ögonblicksbild av emulatorns aktuella tillstånd och sedan gå tillbaka till ett tidigare tillstånd eller framåt igen. Du kan också spara emulatortillståndet med alla aktuella ögonblicksbilder.",
    "pauseButton": "Du kan pausa emulatorn när som helst och frysa 6502-processorn. Det är användbart för att stoppa spelet tillfälligt eller öppna felsökaren.",
    "debugButton": "Klicka på insektssymbolen för att öppna felsökningsläget, där du kan se 6502-processorns interna tillstånd. Klicka igen för att återgå till normalt läge.",
    "configButtons": "Den nedersta raden med knappar styr Apple II:s tillstånd: emulatorhastighet, skärmfärg och ljudavstängning.",
    "retroConfigButtons": "Alternativmenyn styr Apple II:s tillstånd: emulatorhastighet, skärmfärg och ljudavstängning.",
    "keyboardButtons": "När Caps Lock är aktiverat skrivs alla tecken med VERSALER.",
    "altArrowKeys": "Nästa tangent avgör om tangenten {{modKey}} används för kortkommandon eller Apple II:s Open Apple-tangent. Den sista tangenten avgör om piltangenterna kan användas som Apple II-styrspak.",
    "clearCookies": "Apple2TS sparar automatiskt de aktuella emulatorinställningarna som webbläsarkakor. Tryck på den här knappen för att återställa inställningarna och ta bort kakorna.",
    "retroClearCookies": "Apple2TS sparar automatiskt de aktuella emulatorinställningarna som webbläsarkakor. Välj det här alternativet för att återställa inställningarna och ta bort kakorna.",
    "debugWelcome": "Apple2TS har många verktyg för att analysera och felsöka 6502-assemblerkod.",
    "debugIcon": "Klicka på insektssymbolen på informationsflikarna för att visa felsökningspanelen.",
    "debugPause": "Tryck på Paus för att pausa eller återuppta emulatorns körning.",
    "debugControls": "Nu när körningen är pausad kan vi stega genom den avassemblerade koden med knapparna Stega över, Stega in och Stega ut. Vi kan också snabbt hoppa till programräknarens (PC) aktuella adress.",
    "debugDisassembly": "Här visas den avassemblerade koden med hexadecimala adresser, instruktioner med tre bokstäver samt värden och adresser. Om du håller muspekaren över ett grönt värde visas en verktygstipsruta med det aktuella värdet. Klicka på en blå adress för att rulla till den platsen. Du kan också klicka i vänstermarginalen för att lägga till eller ta bort brytpunkter.",
    "debugInfo": "I mitten finns stackdumpen och en minneskarta. Minneskartan uppdateras i realtid och visar vilka minnesbanker som är aktiva.",
    "debugMemory": "Den sista delen visar Apple II-minnet. Använd rullistan för att undersöka olika minnesområden. Om du växlar till någon av HGR-sidorna får du en förstorad vy av högupplösningsskärmen som är kopplad till minnesplatserna. Du kan också söka efter hexadecimala värden eller ASCII-strängar och spara minnet till en fil.",
    "back": "Tillbaka",
    "close": "Stäng",
    "last": "Slutför",
    "next": "Nästa",
    "nextLabelWithProgress": "Nästa (steg {step} av {steps})",
    "skip": "Stäng",
    "guidedTour": "Genomgångar",
    "mainLabel": "Guidad genomgång: huvudmeny",
    "settingsLabel": "Guidad genomgång: inställningar",
    "debugLabel": "Guidad genomgång: felsökning"
  },
  "disk": {
    "drive1": "Enhet 1",
    "drive2": "Enhet 2",
    "hardDisk": "Hårddisk",
    "eject": "Mata ut disk",
    "insert": "Sätt in disk",
    "writeProtected": "Skrivskyddad",
    "readWrite": "Läs/skriv",
    "empty": "Tom",
    "loading": "Läser in…",
    "selectDisk": "Välj diskavbildning",
    "browse": "Bläddra",
    "internetArchive": "Internet Archive",
    "totalReplay": "Total Replay",
    "newReleases": "Nya utgåvor",
    "writeProtectDisk": "Skrivskydda disk",
    "saveDiskToDevice": "Spara Disk",
    "saveDiskTo": "Spara Disk till",
    "saveDiskToMenu": "Spara Disk till >",
    "addToFavorites": "Lägg till i Favoriter",
    "downloadDisk": "Hämta disk",
    "downloadWoz": "Hämta WOZ-diskavbildning",
    "downloadAndEjectDisk": "Hämta och mata ut disk",
    "ejectDisk": "Mata ut disk",
    "ejectAllDisks": "Mata ut alla diskar",
    "saveDiskToOneDrive": "Spara disk på OneDrive",
    "saveDiskToGoogleDrive": "Spara disk på Google Drive",
    "loadDisk": "Läs in disk…",
    "loadAdditionalDisks": "Läs in ytterligare disk…",
    "loadDiskFrom": "Ladda Disk från",
    "loadDiskFromMenu": "Ladda Disk från >",
    "loadDiskFromDevice": "Läs in disk",
    "loadDiskFromDeviceReadOnly": "Läs in disk från enhet (skrivskyddat)",
    "loadDiskFromDeviceReadWrite": "Läs in disk från enhet (läs/skriv)",
    "InternetArchive": "Internet Archive",
    "DemoZoo": "DemoZoo",
    "OneDrive": "OneDrive",
    "GoogleDrive": "Google Drive",
    "loadDiskFromInternetArchive": "Läs in disk från Internet Archive",
    "loadDiskFromDemoZoo": "Läs in disk från DemoZoo",
    "loadDiskFromOneDrive": "Läs in disk från OneDrive",
    "loadDiskFromGoogleDrive": "Läs in disk från Google Drive",
    "insertBlankDisk": "Sätt in tom disk",
    "syncEveryMinute": "Synkronisera varje minut",
    "syncEvery5Minutes": "Synkronisera var femte minut",
    "pauseSyncing": "Pausa synkronisering",
    "syncNow": "Synkronisera nu",
    "modified": "ändrad",
    "synced": "Synkroniserad",
    "diskImage": "Diskavbildning",
    "diskDrivesAndDevices": "diskenheter och enheter",
    "syncedAt": "Synkroniserad {{date}}",
    "clickToHide": "Klicka för att dölja",
    "clickToShow": "Klicka för att visa",
    "clickToLoadDiskImage": "Klicka för att läsa in diskavbildning(ar)",
    "downloadingDisk": "Hämtar disk",
    "clickToRemoveFromDiskCollection": "Klicka för att ta bort från disksamlingen",
    "clickToAddToDiskCollection": "Klicka för att lägga till i disksamlingen",
    "byCreator": "av {{creator}}",
    "clickToViewDetails": "Klicka för att visa detaljer",
    "importImageIntoEmulator": "Importera diskavbild till emulatorn",
    "downloadDiskImage": "Hämta diskavbild",
    "standbyDisks": "Standby-diskar (Klicka för att byta disk)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "Apple IIe-emulator i TypeScript",
    "credit": "© {{year}} Chris Torrence och Apple2TS-bidragsgivarna",
    "keyboardShortcuts": "Kortkommandon",
    "shortcutsUnavailable": "Emulatorns kortkommandon med {{keyMod}} är inte tillgängliga när tangenten är tilldelad Open Apple. Ctrl+0 till Ctrl+5 väljer fortfarande emulatorhastighet.",
    "diskImages": "Diskavbildningar:",
    "diskContainers": "Komprimerade arkiv:",
    "multiDiskNotice": "Växla flera disketter: Klicka på multi-disk-märket för att öppna snabbväxlingsmenyn. Multi-diskarkiv (.zip, .7z, .gz) läses automatiskt in i växlingslistan.",
    "urlParameters": "Valfria URL-parametrar",
    "examples": "Exempel",
    "mobileInstructions": "Mobila plattformar:",
    "tapScreen": "Tryck på skärmen för att visa tangentbordet.",
    "arrowKeys": "Tryck på piltangenterna, Esc eller Tab för att skicka tangenterna till emulatorn.",
    "ctrlKey": "Skicka ett kontrolltecken genom att trycka en gång på Ctrl. Tryck sedan på skärmen för att visa tangentbordet och välj önskad tangent. Ctrl släpps automatiskt.",
    "ctrlLock": "Skicka flera kontrolltecken genom att trycka två gånger på Ctrl för att låsa den (visas med en grön punkt). Tryck sedan på skärmen för att visa tangentbordet och välj önskade tangenter. Tryck på Ctrl igen för att släppa den.",
    "appleKeys": "Tangenterna Open Apple och Closed Apple fungerar på samma sätt som Ctrl.",
    "controlPanelShortcut": "SKIFT+ESC: visa Apple2TS-kontrollpanelen",
    "openAppleKey": "Open Apple: tryck på vänster Alt/Option",
    "closedAppleKey": "Closed Apple: tryck på höger Alt/Option",
    "joystickKeys": "Styrspakstangenter: numeriskt tangentbord 8/2/4/6 (7/9/1/3), 0/5 samt punkt- eller Retur-tangenten",
    "onScreenKeyboard": "För skärmtangentbordet: använd CTRL eller ESC.\nTryck en gång på tangenten för att aktivera den och sedan på önskad bokstavstangent.",
    "urlParametersBody": "Lägg till valfria URL-parametrar efter frågetecknet (?) i URL:en och skilj flera parametrar åt med et-tecknet (&). Använd # för att ange diskavbildningen. Se dialogrutan Länkbyggare för exempel.",
    "exampleLinks": {
      "totalReplayDebugging": "Total Replay med felsökning",
      "totalReplayChoplifter": "Total Replay, läs in Choplifter, inbäddat läge",
      "a2Desktop": "A2Desktop 2MG med snabb hastighet och färg",
      "embeddedBasic": "Inbäddat Applesoft BASIC-program",
      "binaryHexAddress": "Binärfil med hexadecimal adress"
    },
    "links": "Länkar",
    "resourceLinks": {
      "desktopApp": "Apple2TS skrivbordsapp",
      "corsProxy": "CORS-proxy från Corsfix",
      "silverCjkFont": "Silver CJK-pixeltypsnitt"
    }
  },
  "messages": {
    "loading": "Läser in…",
    "fetchingCloudData": "Hämtar molndata",
    "error": "Fel",
    "success": "Lyckades",
    "confirm": "Bekräfta",
    "cancel": "Avbryt",
    "ok": "OK",
    "on": "på",
    "off": "av",
    "confirmTheme": "Läs in emulatorn på nytt och tillämpa det här temat nu?",
    "confirmReset": "Återställa alla inställningar till standardvärden?",
    "fileNotFound": "Filen hittades inte",
    "invalidFile": "Ogiltigt filformat",
    "diskInserted": "Disk har satts in",
    "diskEjected": "Disk har matats ut"
  },
  "keyboard": {
    "capsLock": "Caps Lock",
    "shift": "Skift",
    "ctrl": "Ctrl",
    "alt": "Alt",
    "openApple": "Open Apple",
    "closedApple": "Closed Apple",
    "escape": "Esc",
    "tab": "Tabb",
    "enter": "Retur",
    "space": "Mellanslag",
    "backspace": "Backsteg",
    "delete": "Ta bort",
    "return": "Retur",
    "enableGamePatches": "Aktivera spelpatchar"
  },
  "audio": {
    "speaker": "Högtalare",
    "mockingboard": "Mockingboard",
    "midi": "MIDI",
    "configuration": "Ljudkonfiguration",
    "volume": "Volym",
    "mute": "Tysta",
    "waveform": "Vågform"
  },
  "print": {
    "printer": "Skrivare",
    "imageWriter": "ImageWriter",
    "imageWriterII": "ImageWriter II (kortplats 1)",
    "print": "Skriv ut",
    "clear": "Rensa",
    "save": "Spara utdata",
    "dumpScreen": "Skriv ut aktuell skärm på skrivaren",
    "dumpScreenInverse": "Skriv ut aktuell skärm (inverterad)",
    "sendToPrinter": "Skicka till skrivaren",
    "tearOff": "Riv av sidan och återställ",
    "printedPage": "Utskriven sida",
    "printerConfig": "Skrivarkonfiguration",
    "pageLength": "Sidlängd",
    "pageLengthLetter": "11 tum (Letter)",
    "pageLengthA4": "11,7 tum (A4)",
    "pageLengthTwelve": "12 tum"
  },
  "device": {
    "machineConfiguration": "Maskinkonfiguration",
    "midiDeviceSelect": "Välj MIDI-enhet",
    "serialPortSelect": "Välj serieport",
    "mockingboardWaveform": "Mockingboard-vågform"
  },
  "collection": {
    "showApple2TSCollection": "Visa Apple2TS-samlingen",
    "showNewReleases": "Visa nya utgåvor",
    "showFavorites": "Visa favoriter",
    "chooseDiskImage": "Välj diskavbildning",
    "diskCollection": "Disksamling",
    "clickToShowDetails": "Klicka för att visa detaljer för",
    "clickToLoadDisk": "Klicka för att läsa in disk",
    "diskIsNewRelease": "Disken är en ny utgåva",
    "diskIsApple2TSCollection": "Disken ingår i Apple2TS-samlingen",
    "diskIsInternetArchive": "Disken ingår i Internet Archive",
    "diskIsDemoZoo": "Disken ingår i DemoZoo",
    "clickToRemoveFromCollection": "Klicka för att ta bort från disksamlingen",
    "clickToKeepInCollection": "Klicka för att behålla i disksamlingen",
    "clickToAddToCollection": "Klicka för att lägga till i disksamlingen",
    "diskIsSyncedVia": "Disken synkroniseras via",
    "loadDiskIntoDrive": "Läs in disk i enhet",
    "cloudAuthRequired": "Autentisering krävs",
    "signIn": "Logga in",
    "exportDisksToHdv": "Exportera diskar till HDV",
    "export": "Exportera",
    "clickToRemoveFromSelected": "Klicka för att ta bort från valda diskar",
    "clickToAddToSelected": "Klicka för att lägga till i valda diskar",
    "reportExportIssue": "Rapportera ett exportproblem",
    "hdvExportTitleUnavailable": "Apple2TS kunde inte ta med ”{{title}}” i HDV-filen.",
    "continueHdvExportWithoutUnavailableTitles": "Fortsätt skapa HDV-filen och hoppa över otillgängliga titlar?",
    "exportUnavailable": "Den här disken kan inte exporteras",
    "exportTooLarge": "Den här disken är för stor för att exporteras",
    "exportCopyProtected": "Kopieringsskydd hindrar export av den här disken",
    "exportDosMasterIncompatible": "Den här disken är inte kompatibel med DOS.MASTER",
    "exportStatusPending": "Kontrollerar om disken kan exporteras",
    "exportAvailable": "Disken kan exporteras",
    "creatingHdv": "Skapar HDV-avbildningen",
    "hdvCreatedWithOmissions": "Apple2TS skapade HDV-filen men utelämnade några titlar:\n\n{{details}}",
    "hdvCreationFailed": "Apple2TS kunde inte skapa HDV-filen: {{message}}",
    "hdvDownloadFailed": "Apple2TS kunde inte hämta disken, så skapandet av HDV-filen avbröts.",
    "fetchingDisk": "Hämtar disk {{current}} av {{total}}",
    "checkingDiskForExport": "Kontrollerar disk {{current}} av {{total}} för export",
    "selectAllDisks": "Markera alla diskar",
    "clearDiskSelection": "Rensa diskmarkering",
    "deleteAllBookmarks": "Ta bort alla bokmärken",
    "restoreAllBookmarks": "Återställ alla bokmärken",
    "sort": {
      "nameAscending": "A–Ö",
      "nameDescending": "Ö–A",
      "newest": "Nyast",
      "oldest": "Äldst"
    }
  },
  "debugControls": {
    "goBackInTime": "Gå tillbaka i tiden",
    "takeSnapshot": "Ta en ögonblicksbild",
    "goForwardInTime": "Gå framåt i tiden",
    "saveStateWithSnapshots": "Spara tillstånd med ögonblicksbilder",
    "resume": "Återuppta",
    "pause": "Pausa",
    "trace": "Spårning",
    "tracing": "Spårning pågår",
    "downloadTraceLog": "Hämta spårningslogg"
  },
  "fullscreen": {
    "fullScreen": "Helskärm"
  },
  "internetArchive": {
    "searchPlaceholder": "Skriv namnet på en programtitel eller klicka på någon av kategorierna ovan",
    "go": "SÖK"
  },
  "demoZoo": {
    "searchPlaceholder": "Sök i DemoZoo (titel, upphovsperson)…",
    "go": "SÖK",
    "all": "Alla",
    "demo": "Demo",
    "intro": "Intro",
    "cracktro": "Cracktro",
    "music": "Musik",
    "previous": "Föregående",
    "next": "Nästa",
    "firstPage": "Första sidan",
    "lastPage": "Sista sidan",
    "pageInput": "Sidnummer",
    "pageOf": "Sida {{page}} av {{pages}}",
    "noProductions": "Inga DemoZoo-produktioner hittades.",
    "youtubeOnly": "Den här produktionen har bara en YouTube-videolänk:",
    "externalOnly": "Den här produktionen har bara en extern DemoZoo-länk:",
    "openInNewTab": "Öppna i ny flik",
    "snapshotBadge": "Ögonblicksbild {{date}}",
    "snapshotCreated": "DemoZoo-ögonblicksbild skapad: {{date}}"
  },
  "basic": {
    "newProgram": "Nytt program",
    "newProgramWarning": "Detta rensar det aktuella programmet. Alla osparade ändringar går förlorade. Är du säker?",
    "runFromBeginning": "Kör från början",
    "break": "Avbrott",
    "continueRunning": "Fortsätt köra",
    "stepProgram": "Stega programmet",
    "resumeOutput": "Återuppta utdata",
    "freezeOutput": "Frys utdata",
    "importProgram": "Importera program…",
    "exportProgram": "Exportera program…",
    "renumberProgram": "Numrera om program",
    "rebuildProgram": "Bygg om program från minnet",
    "displaySettings": "Skärminställningar",
    "autoLineNumbering": "Automatisk radnumrering",
    "capitalizeKeywords": "Skriv nyckelord med versaler",
    "rebuildWarning": "Detta ersätter det aktuella programmet med en version som byggts om från Apple II-minnet. Alla osparade ändringar går förlorade. Är du säker?",
    "variable": "Variabel",
    "value": "Värde"
  },
  "expectin": {
    "runScript": "Kör skript",
    "stopScript": "Stoppa skript"
  },
  "saveDisassembly": {
    "title": "Spara avassemblering",
    "startAddress": "Startadress $",
    "endAddress": "Slutadress $",
    "includeLabels": "Inkludera symbolbeteckningar",
    "separatorLines": "Skiljelinjer efter JMP, RTS"
  },
  "gamepad": {
    "useArrowKeys": "Använd piltangenter som styrspak",
    "siriusJoyport": "Sirius Joyport-läge",
    "reverseYAxis": "Invertera Y-axeln för styrspaken",
    "touchJoystick": "Styrspak för pekskärm",
    "tiltSensorJoystick": "Använd lutningssensor som styrspak"
  },
  "traceSettings": {
    "title": "Spårningsinställningar",
    "numLines": "Antal rader att behålla:",
    "rangeWarning": "Måste vara mellan 100 och 100000",
    "collapseLoops": "Hitta upprepade rader och fäll ihop slingor",
    "ignoreRegisters": "Ignorera registervärden när upprepade rader hittas",
    "settings": "Inställningar",
    "unlimited": "Obegränsat",
    "cyclesUnit": "cykler"
  },
  "keyboardControl": {
    "hideKeyboard": "Dölj tangentbord",
    "showKeyboard": "Visa tangentbord"
  },
  "linkBuilder": {
    "title": "Länkbyggare",
    "buttonTitle": "Länkbyggare",
    "userInterface": "Användargränssnitt:",
    "machine": "Maskin:",
    "colorMode": "Färgläge:",
    "ramDiskSize": "RAM-diskens storlek (KB):",
    "emulatorSpeed": "Emulatorns hastighet:",
    "uiTheme": "Tema för användargränssnittet:",
    "showDebugTab": "Visa felsökningsflik",
    "sound": "Ljud",
    "startupOptionsTab": "Startalternativ",
    "onStartup": "Vid start:",
    "loadDiskImage": "Läs in diskavbildning",
    "loadBasicProgram": "Läs in BASIC-program",
    "loadHexCode": "Läs in hexkod",
    "diskImageToLoad": "Diskavbildning att läsa in vid start:",
    "customDiskUrl": "Anpassad URL för diskavbildning:",
    "textToType": "Text att skriva efter att disken lästs in:",
    "enterTextPlaceholder": "Ange text eller BASIC-kod här",
    "runBasicAfterLoading": "Kör BASIC-programmet efter inläsning",
    "enterHexPlaceholder": "Ange hexadecimal kod här, t.ex. A9 01 8D 00 03",
    "hexLoadAddress": "Hexadecimal inläsningsadress: $",
    "runHexAfterLoading": "Kör hexprogrammet efter inläsning",
    "finalUrl": "Slutlig URL:",
    "copyToClipboard": "Kopiera till urklipp",
    "tryIt": "Prova",
    "reset": "Återställ",
    "close": "Stäng",
    "customDiskUrlOption": "Anpassad URL",
    "gameModes": {
      "normal": "Normal",
      "game": "Spel (inga enheter eller flikar)",
      "embed": "Bädda in (dölj alla reglage)"
    },
    "colorNames": {
      "color": "Färg",
      "nofringe": "Färg (utan fransar)",
      "green": "Grön skärm",
      "amber": "Bärnstensskärm",
      "white": "Vit skärm",
      "inverse": "Inverterat vitt"
    },
    "speedNames": {
      "snail": "Snigel",
      "slow": "Långsam",
      "normal": "1 MHz (standard)",
      "two": "2 MHz",
      "three": "3 MHz",
      "four": "4 MHz",
      "warp": "Löjlig"
    },
    "machines": {
      "enhanced": "Apple IIe utökad",
      "unenhanced": "Apple IIe utan utökning",
      "apple2p": "Apple II+"
    },
    "themes": {
      "classic": "Klassisk",
      "dark": "Mörk",
      "minimal": "Minimal"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192",
      "default": "64 (standard)"
    },
    "slots": {
      "configure": "Konfigurera kortplatser",
      "slot": "Kortplats {{slot}}:",
      "cardNone": "Ingen (tom)"
    },
    "additionalDiskDrives": "Ytterligare diskenheter",
    "slot6Drive1": "Kortplats 6 Enhet 1 (Diskett 1)",
    "slot6Drive2": "Kortplats 6 Enhet 2 (Diskett 2)",
    "slot7Drive1": "Kortplats 7 Enhet 1 (Hårddisk 1)",
    "slot7Drive2": "Kortplats 7 Enhet 2 (Hårddisk 2)",
    "slot2Drive1": "Kortplats 2 Enhet 1 (VERA SD)",
    "slot4Drive1": "Kortplats 4 Enhet 1 (VERA SD)",
    "addAdditionalDisk": "Lägg till ytterligare disk för byte",
    "removeDisk": "Ta bort denna disk",
    "addAnotherDisk": "Lägg till ytterligare en disk",
    "diskPlaceholder": "Disk {num} filnamn (t.ex. sideB.woz|Scenariodisk)"
  },
  "agent": {
    "tabTitle": "Agent",
    "setupTitle": "🤖 Konfigurera AI-agent",
    "setupInstruction": "Klicka på kugghjulsikonen nedan för att konfigurera din AI-assistent.",
    "welcomeTitle": "Välkommen till Apple II-assistenten! Jag kan hjälpa dig med:",
    "welcomeItem1": "Kontroll av CPU-register och minne",
    "welcomeItem2": "Styrning av körning (start, återställning, stegning, brytpunkter)",
    "welcomeItem3": "Inläsning av program och hantering av diskar",
    "welcomeItem4": "Felsökning av 6502-assemblerkod",
    "welcomeItem5": "Läsning av skärminnehåll och systemtillstånd",
    "welcomePrompt": "Fråga mig vad som helst!",
    "userRole": "Du",
    "assistantRole": "🤖 Assistent",
    "inputPlaceholder": "Fråga mig vad som helst om Apple II-emulatorn… (tryck på Retur för att skicka, Skift+Retur för ny rad)",
    "stop": "Stoppa",
    "send": "Skicka",
    "changeConfiguration": "Ändra konfiguration",
    "processing": "Bearbetar…",
    "tokens": "• {{input}} in / {{output}} ut",
    "configTitle": "Konfigurera AI-agent",
    "provider": "Leverantör:",
    "model": "Modell:",
    "apiKey": "API-nyckel:",
    "ollamaUrl": "Ollama-URL:",
    "save": "Spara",
    "clear": "Rensa",
    "storageWarning": "Din API-nyckel lagras lokalt i webbläsaren och skickas aldrig till apple2ts.com. Hämta API-nyckeln för {{provider}} på",
    "ollamaWarning": "Ollama körs lokalt på datorn. Kontrollera att Ollama är installerat och körs. Hämta det från",
    "providerNotConfigured": "Leverantören är inte konfigurerad – klicka på kugghjulsikonen för att ställa in AI-agenten",
    "providerConfigured": "Leverantör: {{provider}} ({{model}})",
    "invalidKeyFormat": "Ogiltigt API-nyckelformat för {{provider}}",
    "customModel": "Anpassad modell…",
    "customModelName": "Namn på anpassad modell:"
  },
  "startup": {
    "welcome": "Välkommen till Apple2TS",
    "subtitle": "Apple II-emulator i TypeScript",
    "copyright": "© {{year}} C. Torrence och medarbetare",
    "diskCollections": "Klicka på ikonen Disksamling\nför att läsa in en inbyggd disk eller ett spel.",
    "retroControlPanel": "Tryck på SKIFT+ESC för att visa\nkontrollpanelen."
  },
  "retroControl": {
    "ariaLabel": "Apple2TS-kontrollpanel",
    "machine": "Maskin",
    "fullscreen": "Helskärm",
    "diskCollection": "Diskar",
    "diskDrives": "Diskenheter",
    "display": "Bildskärm",
    "monitorMode": "Bildskärmsläge",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "Ljud",
    "options": "Alternativ",
    "skin": "Utseende",
    "personalization": "Anpassning",
    "text": "Text",
    "background": "Bakgrund",
    "border": "Kant",
    "iigsColor": {
      "black": "Svart",
      "red": "Röd",
      "darkBlue": "Mörkblå",
      "purple": "Lila",
      "darkGreen": "Mörkgrön",
      "darkGray": "Mörkgrå",
      "mediumBlue": "Mellanblå",
      "lightBlue": "Ljusblå",
      "brown": "Brun",
      "orange": "Orange",
      "lightGray": "Ljusgrå",
      "pink": "Rosa",
      "lightGreen": "Ljusgrön",
      "yellow": "Gul",
      "aquamarine": "Akvamarin",
      "white": "Vit"
    },
    "keyboard": "Tangentbord",
    "input": "Indata",
    "joystick": "Styrspak",
    "slots": "Kortplatser",
    "devices": "Enheter",
    "printerPort": "Skrivarport",
    "modemPort": "Modemport",
    "quit": "Avsluta",
    "apple2tsCollection": "Apple2TS-samling",
    "newReleases": "Nya utgåvor",
    "favorites": "Favoriter",
    "exportDisksToHdv": "Exportera diskar till HDV",
    "noDiskDrivesAvailable": "Inga diskenheter tillgängliga",
    "select": "Välj",
    "open": "Öppna",
    "load": "Ladda",
    "go": "Kör",
    "save": "Spara",
    "clipboard": "Urklipp",
    "cancelEsc": "Avbryt:Esc",
    "color": "Färg",
    "colorNoFringe": "Färg (utan fransar)",
    "green": "Grön",
    "amber": "Bärnsten",
    "white": "Vit",
    "inverse": "Inverterad",
    "snail": "Snigel",
    "slow": "Långsam",
    "normal": "Normal",
    "twoMhz": "2 MHz",
    "threeMhz": "3 MHz",
    "fast": "Snabb",
    "warp": "Warp",
    "systemSpeed": "Systemhastighet",
    "other": "Övrigt",
    "timeMachine": "Ögonblicksbilder",
    "ports": "Portar",
    "language": "Språk",
    "port": "Port",
    "builtinImageWriter": "Inbyggd ImageWriter",
    "selectExternalPort": "Välj extern port",
    "externalPort": "Extern port",
    "retroTheme": "Retro",
    "lowercaseInput": "Inmatning med gemener",
    "lowercase": "Gemener",
    "openAppleKey": "Open Apple-tangent",
    "sortOrder": "Sortera",
    "slot": "Kortplats {{slot}}",
    "drive": "{{drive}}: {{disk}}",
    "configured": "{{count}} konfigurerad",
    "saveDisk": "Spara disk",
    "card": {
      "empty": "Tom",
      "ssc": "Super Serial Card",
      "softcard": "Z-80 SoftCard",
      "aux": "Extraminne",
      "videoterm": "Videx VideoTerm",
      "mockingboard": "Mockingboard",
      "mouse": "Muskort",
      "vera": "VERA-grafik",
      "passport": "Passport MIDI",
      "disk2": "Disk II-styrenhet",
      "smartport": "SmartPort-enhet"
    },
    "fetchingDisk": "Hämtar disk {{current}}/{{total}}",
    "downloadFailed": "Kunde inte hämta {{title}}",
    "exportFailed": "Export till HDV misslyckades: {{message}}"
  },
  "binaryFile": {
    "title": "Läs in binärfil",
    "loadAtAddress": "Läs in i minnet på adressen $",
    "runAfterLoading": "Kör koden efter inläsning"
  }
}
